<div class="flex w-full flex-col">
    <!-- header -->
    <div class="fixed top-0 z-10 flex h-18 w-full items-center justify-between bg-white px-6 shadow-sm">
        <div class="w-10">
            <img
                src="images/logo/brand-amex.svg"
                alt=""
            />
        </div>

        <div>
            <user></user>
        </div>
    </div>
    <!-- Main -->
    <section class="mt-18 flex flex-grow">
        <div class="flex w-full items-center justify-center">
            <profile-change-password
                [store]="store"
                (savechange)="onSave()"
                (cancel)="onCancel()"
            ></profile-change-password>
        </div>
    </section>
    <section
        class="px-6 py-4 text-sm text-neutral-500"
        [innerHTML]="copyrights"
    ></section>
</div>
